import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { NavController, LoadingController, NavParams, ModalController, ToastController, AlertController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { GrupoProvider } from 'src/app/services/grupo/grupo';


@Component({
  selector: 'app-grupo-transferir-participantes',
  templateUrl: './grupo-transferir-participantes.page.html',
  styleUrls: ['./grupo-transferir-participantes.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    SemRegistroComponent
  ],
})
export class GrupoTransferirParticipantesPage implements OnInit {
  pessoa: any = {};
  grupoCargos: any = [];
  idGrupo: any;
  grupo: any;
  grupoL: any;
  nome: any;
  participante: any = {};
  idParticipante: any;
  tipo: any;
  validations_form!: FormGroup;
  filtroGrupo: any = "";
  paginationGrupo: any = { currentPage: 0, pageCount: 0 };
  grupoList: any = [];
  participantes: any = {};
  constructor(
    public navCtrl: NavController,
    public loadingController: LoadingController,
    public navParams: NavParams,
    private translate: TranslateService,
    public grupoProvider: GrupoProvider,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
  ) {
    this.idGrupo = navParams.get('idGrupo');
    this.participante = this.navParams.get('participante');
    this.tipo = this.navParams.get('tipo');
    this.nome = this.participante.nome;
    this.idParticipante = this.participante.id;

    this.loadGrupo(null);

    this.grupoProvider.buscarTodosGrupos(this.filtroGrupo, this.paginationGrupo, this.idGrupo, this.tipo).subscribe(res => {
      this.grupoL = res.nome.length >= 0;
    })

  }

  ngOnInit() {
  }

  onCancel() { }

  async openPage(idGrupo: any) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Confirmar transferência'),
      message: this.translate.instant('Transferência do(a) participante ') + this.nome,
      buttons: [
        {
          text: this.translate.instant('Cancelar'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('Confirmar'),
          handler: data => {

            this.grupoProvider.getValidaRegra(idGrupo, this.idParticipante).subscribe(async data => {
              if (!data.status) {
                let alert = await this.alertCtrl.create({
                  message: this.translate.instant(data.message),
                  buttons: [
                    {
                      text: this.translate.instant('Fechar'),
                      handler: () => { }
                    },
                  ]
                })
                alert.present();

              } else {
                this.grupoProvider.removerParticipanteGrupo(this.idGrupo, this.idParticipante, idGrupo, this.tipo).subscribe((data) => {
                  this.grupoProvider.getMigraParticipante(idGrupo, this.idParticipante).subscribe(async data => {
                    let alert = await this.alertCtrl.create({
                      message: this.translate.instant('Participante migrado(a) com sucesso!'),
                      buttons: [
                        {
                          text: this.translate.instant('Fechar'),
                          handler: async (back = true) => {
                            if (back) {
                              const toast = await this.toastCtrl.create({
                                message: this.translate.instant('Participante migrado(a) com sucesso!'),
                                duration: 3000
                              });

                              toast.present();
                              this.modalCtrl.dismiss(true);
                            }

                          }
                        },
                      ]
                    })

                    alert.present();
                  });
                });
              }
            });

          }
        }
      ]
    });
    alert.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }

  loadGrupo(infiniteScroll: { target: { complete: () => void; }; } | null) {
    this.paginationGrupo.currentPage++;

    if (!infiniteScroll) {
      this.paginationGrupo = { currentPage: 0, pageCount: 10 };
    }

    this.grupoProvider.buscarTodosGrupos(this.filtroGrupo, this.paginationGrupo, this.idGrupo, this.tipo).subscribe(res => {
      this.grupo = res;
      if (!infiniteScroll) {
        this.grupoList = [];
      }

      this.grupoList = this.grupoList.concat(res.nome);
      this.paginationGrupo = res.pagination;

      if (infiniteScroll)
        infiniteScroll.target.complete();
    });
  }

  onInputGrupo() {
    this.loadGrupo(null);
  }
}
